/**
 * AnimateIn – reveals title text from the bottom using clip-path and word spans.
 * When in view, sets [animate] and words slide up into place.
 * Requires child with data-animate-in-el="title" (the title element to split and animate).
 */
class AnimateIn extends window.BAO.CustomElement() {
  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (typeof Shopify !== 'undefined' && Shopify.designMode) return

    super.connectedCallback()

    this.splitWords()

    const isSm = window.matchMedia('(min-width: 768px)').matches
    const amountIntoViewport = isSm ? '-60px' : '-50px'

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      rootMargin: amountIntoViewport,
      threshold: 0,
    })

    this.observer.observe(this)
  }

  disconnectedCallback () {
    super.disconnectedCallback?.()
    this.observer?.disconnect()
    this.observer = null
  }

  onEntry ([entry], observer) {
    if (!entry?.isIntersecting) return

    this.setAttribute('animate', '')
    observer.unobserve(this)
  }

  splitWords () {
    const titleEls = this.els?.title?.exists
      ? this.els.title.elements
      : Array.from(this.querySelectorAll('[data-animate-in-el="title"]'))
    if (!titleEls?.length) return

    titleEls.forEach((titleEl) => {
      const wordsArray = titleEl.innerText.replace(/\n/g, ' <br> ').split(' ')
      let titleContent = ''

      wordsArray.forEach((word) => {
        titleContent +=
          word === '<br>'
            ? '<br>'
            : `<span class="ani-Title"><span class="ani-Title_Word">${word}</span></span> `
      })

      titleEl.innerHTML = titleContent
    })
  }
}

if (!customElements.get('animate-in')) {
  customElements.define('animate-in', AnimateIn)
}

export default AnimateIn
